export default {
    行情: "시세",
    了解最新行情和交易大数据: "최신 시세 및 거래 빅 데이터 이해",
    热门榜: "인기 순위",
    新币榜: "새 화폐 랭킹",
    涨幅榜: "상승폭 순위",
    热门合约: "인기 계약",
    交易: "거래",
    现货交易: "현물 거래",
    币币闪兑: "코인 플래시, 빠른 거래",
    搜索: "검색",
    主流币: "주류 화폐",
    热门: "인기",
    合约: "계약",
    永续: "영속",
    灵活杠杆: "유연한 레버리지, 높은 수익",
    金融业务: "금융 업무",
    店铺展示: "점포 전시",
    '门店编号': "매장 번호",
    '城市': "도시",
    '地址': "주소",
    'show1': '2030년까지 Crocodile의 제휴 매장 수는 100000개에 달할 것으로 예상된다.',
    'show2': '모든 매장은 진실, 독립된 신분 ID를 가지고 있으며, 모든 진실, 유효, 공개, 투명!',
    'show3': '암호화폐 × 커뮤니티 서비스 × 협력 상생',
    'show4': 'Crocodile Exchange 제휴점 프로그램 · 로컬 비즈니스의 새로운 생태계 조성',
    优质项目起飞的地方: "양질의 프로젝트가 이륙하는 곳",
    解锁潜质代币: "잠재 토큰의 잠금 해제",
    定期挖矿: "정기적으로 채굴하다.",
    更多个性化选择: "다양한 맞춤형 옵션",
    暂无数据: "데이터 없음",
    探索数字资产的无限可能: "디지털 자산의 무한한 가능성을 탐색하다",
    更多下载选择: "추가 다운로드 옵션",
    注册: "등록",
    开始: "시작",
    "立即注册，免费创建自己的作品集！": "지금 등록하면 자신의 작품집을 무료로 만들 수 있습니다!",
    "布局未来，现在开始": "미래를 배치하고 지금 시작",
    邮箱: "메일박스 / 핸드폰",
    把握交易良机: "다음 거래 기회 포착",
    市场行情: "시장 시세",
    "热门衍生品": "인기 파생상품",
    "热门代币": "인기 토큰",
    主流榜: "메인스트림 차트",
    现货新币榜: "현물 신권 랭킹",
    合约新币榜: "계약 새 코인 랭킹",
    交易对: "거래 쌍",
    最新价: "최신 가격",
    涨跌幅: "등락폭",
    走势图: "동향도",
    成交量: "거래량",
    操作: "작업",
    待上币种: "대기 화폐 종류",
    上线时间: "온라인 시간",
    开盘倒计时: "개장 카운트다운",
    已上币种: "이미 오른 화폐 종류",
    下载应用: "App 다운로드",
    随时随地: "언제 어디서나 거래 개시",
    受千万用户信赖的加密货币交易所: "천만 명의 사용자에게 신뢰받는 암호화폐 거래소",
    强大的交易体验: "강력한 거래 환경",
    提供多种加密货币交易: "다양한 암호화폐 거래를 제공하고 현물, 계약, 주문 등 다양한 제품을 커버하여 다양한 투자 수요를 만족시킨다",
    全天服务: "7*24시간 서비스",
    提供全天候服务: "24시간 온라인으로 연중무휴 24시간 서비스를 제공하는 전문 고객센터",
    安全合规: "보안 규정 준수",
    顶级安全风控体系: "최고급 안전풍력통제체계, 여러 지역의 합규운영, 사용자의 자산안전을 전방위적으로 보호한다.",
    全球化布局: "글로벌 레이아웃",
    值得全球用户信赖: "전 세계 210 + 국가 및 지역을 포괄하며 전 세계 사용자가 신뢰할 수 있으며 언제 어디서나 암호화폐 거래에 참여할 수 있습니다.",
    多种币种: "다종 화폐",
    多种选择: "다양한 옵션",
    全天交易量: "24시간 거래량",
    注册用户: "등록 사용자",
    "用户": "사용자",
    覆盖国家及地区: "국가 및 지역을 포괄하다",
    立即开启您的加密货币交易之旅: "지금 암호화폐 거래 시작",
    即刻开户: "즉시 계좌를 개설하다.",
    自动创建账户: "이메일 / 휴대폰 번호 등록 로그인 후 자동으로 계정 생성",
    钱包充值: "지갑 충전",
    可随时为账户充值: "언제든지 계좌를 충전할 수 있으며, 우리는 주류 채널의 입금을 지원한다",
    开始交易: "거래 시작",
    然后开始交易: "거래할 현금 쌍 또는 계약을 선택하고 거래를 시작합니다.",
    关于我们: "우리에 대해",
    关于: "정보",
    使用者协议: "사용자 프로토콜",
    隐私政策: "개인 정보 보호 정책",
    支持: "지원",
    下载: "다운로드",
    帮助中心: "도움말 센터",
    买币: "화폐를 사다",
    数字货币计算器: "디지털 화폐 계산기",
    购买: "구매",
    联系我们: "연락처",
    社区: "커뮤니티",
    搜寻: "검색",
    此段落内的文章: "이 단락의 기사",
    简介: "소개",
    更新于: "업데이트",
    我们的愿景: "우리의 비전",
    核心优势: "핵심 이점",
    产品与服务: "제품 및 서비스",
    我们的使命: "우리의 사명",
    aboutText1: "Crocodile 거래소는 전 세계 사용자에게 안전하고 효율적이며 투명한 암호화폐 거래 서비스를 제공하기 위해 노력하는 세계 최고의 디지털 자산 거래 플랫폼입니다.업계 내 혁신의 선봉장으로서 Crocodile 는 첨단 블록체인 기술과 금융 보안 시스템을 채택하여 사용자 자산의 안전을 보장하는 동시에 유창하고 안정적인 거래 경험을 제공한다.",
    aboutText2: "Crocodile 거래소의 비전은 세계에서 가장 신뢰할 수있는 디지털 자산 거래 생태계를 구축하고 사용자에게 혁신적이고 합법적이며 다양한 거래 서비스를 제공하며 블록 체인 기술과 디지털 금융의 발전을 촉진하는 것입니다.",
    aboutText3: "최고급 안전방호: 은행급 안전방호체계를 채용하고 다중암호화기술과 랭열지갑의 분리메커니즘을 채용하여 사용자의 자산안전을 보장한다.",
    aboutText4: "고효율 중매 엔진: Crocodile 는 세계 최고의 중매 거래 시스템을 보유하고 있으며 초고속 거래 실행을 지원하여 거래가 원활하고 지연되지 않도록 합니다.",
    aboutText5: "다중 통화 지원: 비트코인(BTC), 이더리움(ETH), USDT 등 다양한 주류 및 양질의 혁신적인 디지털 자산 거래를 지원한다.",
    aboutText6: "글로벌 규정 준수 운영: 각국의 금융 법규를 엄격히 준수하고 거래 규정 준수와 투명성을 확보하며 사용자에게 합법적이고 합법적인 디지털 자산 거래 서비스를 제공한다.",
    aboutText7: "24/7 전문 고객센터: 연중무휴 24시간 다국어 고객 지원을 제공하여 사용자가 문제를 신속하게 해결하고 거래 경험을 최적화할 수 있도록 돕습니다.",
    aboutText8: "현물 거래: 주요 암호화폐 거래 쌍을 제공하고, 낮은 지연, 높은 유동성을 제공하며, 초보자와 전문 거래자에게 적합하다.",
    aboutText9: "계약 거래: 높은 레버리지, 낮은 슬라이딩 포인트, 사용자가 유연한 거래 전략을 실현할 수 있도록 돕습니다.",
    aboutText10: "질권과 재테크: 다양한 수익형 상품을 제공하여 사용자가 자산 증식을 실현하도록 돕는다.",
    aboutText11: "API 거래: 메커니즘과 양적 거래자에게 전문 거래 요구 사항을 충족하는 고성능 API 인터페이스를 제공합니다.",
    aboutText12: "Crocodile 거래소는 항상'사용자 최우선, 보안 최우선, 혁신 구동'이라는 핵심 가치관을 고수하며 전 세계 디지털 자산 거래자에게 원스톱 솔루션을 제공한다.우리는 미래의 금융 시스템이 블록체인에 의해 구동될 것이며, Crocodile 는 지속적으로 산업 발전을 추진하여 전 세계 사용자들에게 더욱 공평하고 효율적이며 투명한 디지털 금융 서비스를 가져다 줄 것이라고 믿는다.",
    aboutText13: "Crocodile 거래소, 미래 금융이 손에 잡힌다!",
    已结束: "종료",
    分发总量: "총 배포",
    个人兑换限额: "개인 환전 한도액",
    最小投入量: "최소 투입량",
    兑换价格: "환전 가격",
    launchpad: "Crocodile Launchpad는 사용자가 초기 단계에서 인기 있는 프로젝트 토큰을 구매할 수 있도록 고안된 양질의 블록체인 신규 프로젝트 리저브 플랫폼이다.",
    launchpad1: "에코링크는 솔라나 블록체인에 배치된 디핀 사물인터넷 장치를 위한 블록체인 예언기이다.또한 고유한 증명 메커니즘을 통해 다양한 사물 인터넷 장치를 브리징하고 확장하며, 그들의 워크로드를 수집, 측정 및 검증함으로써 신뢰할 수 있는 자료 보고서를 생성합니다.이 자료는 제로 지식 증명을 사용하여 암호화되고 Oracle 노드로 전송되며 각 기기 유닛에서 받을 수 있는 보상을 평가합니다.EchoLink는 또한 더 많은 DePIN 프로젝트를위한 인프라가 될 수 있도록 설계된 포괄적인 소프트웨어 SDK 및 하드웨어 설계 조합을 제공합니다.",
    launchpad2: "ACGN 프로토콜은 AI로 구동되는 Web3 ACGN(애니메이션, 만화, 게임, 소설) 창작자 생태계다.오픈 소스 제작자 계약 기준:ACGN Protocol，사용자는 우리의 AI 도구를 이용하여 오리지널 IP에서 파생 콘텐츠를 만들고, 파생 제품과 오리지널 사이의 NFT 콘텐츠 네트워크 연결을 촉진하며, 하향식 ACGN 콘텐츠 창작 생태계를 구축할 수 있다.",
    launchpad3: "MetaExpand，Universal Metaverse Expansion Protocol의 약어입니다.UMM），일반적인 메타 우주 용량 확장 프로토콜입니다.MetaExpand는 메타우주 생태의 하부 인프라로서 공련과 메타우주 응용 사이의 기술 격차를 대폭 낮추고 메타우주 응용 개발을 위한 저장, 통신, 프라이버시, 크로스체인 및 거래의 기초 플러그인과 개발 표준을 제공하여 개발자가 하부 블록체인의 기술 차이를 너무 많이 고려할 필요가 없도록 한다;MetaExpand는 또한 메타 우주 기반 위젯의 패러다임 응용을 제공하여 공공 플러그인으로 사용할 수도 있고 빠른 개발의 출발점으로 사용할 수도 있다;MetaExpand는 다른 주류 퍼블릭 체인과 호환되도록 포지셔닝하고 에너지를 부여하며 메타 우주 생태 개발 능력을 확장하고 가속화합니다.",
    launchpad4: "PINs는 멀티 롤 플레잉을 사용하여 스토리 기반 메타 우주를 만들고 역사적, 문화적 특성을 커뮤니티에 도입하는 콘텐츠 소셜 네트워크입니다.PINs에는 사람들이 다양한 역할을 수행하고 다양한 행동에 참여할 수있는 가상 세계에 해당하는 수많은 장이 있습니다.",
    Launchpool1: "나의 Launchpool",
    Launchpool2: "Metaverse HQ(MVHQ)는 게임을 위한De-Fi、프로토콜, 창작자, NFT/Memecoin 및 탈중심화 생태계의 AI 증강형 임무 프로토콜.MVHQ는 이미 체인 위와 체인 아래 보상의 통용 허브가 되어 사용자에게 수백만 달러의 가치를 나누어 주었다.",
    Launchpool3: "REVOX.AI는 무허가 머신러닝 인프라를 통해 Web3의 공유 AI 인터페이스를 구축하고 있으며, 탈중심화 AI 응용의 개발과 혁신을 부여하고 모듈화 스마트 에이전트의 광범위한 응용을 추진하고 있다.REVOX의 플래그십 슈퍼앱인 Web3 GPT Lense, 스마트 지갑, ReadON DAO 앱은 전 세계적으로 2100만 명 이상의 사용자를 끌어들였다.",
    Launchpool4: "Cellula는 프로그래밍 가능한 인센티브 계층으로 가상 작업량 증명(vPOW) 메커니즘을 이용하여 혁신적인 게임화 발행 방법을 통해 공정한 자산 분배와 유동성 유도를 실현한다.이 프로젝트는 Binance Labs와 OKX Ventures의 지원을 받았습니다.Cellula의 vPOW는'BitLife'실체에 독특한 해시율을 부여하여 게임화된 채굴 과정에 참여하여 동적 인센티브를 생성할 수 있도록 한다.이 혁신적인 채굴 방식은 적응성과 프로그래밍 가능성을 도입하여 Cellula가 전례없는 공정한 자산 분배와 유동성 분배 유도를 실현할 수 있도록 하였는데, 이는 EVM 호환 네트워크의 진정한 최초이다.",
    Launchpool5: "LBank Launchpool에 참여하는 방법",
    全部: "모두",
    报名中: "신청 중",
    预热中: "예열 중",
    待发放: "지급 대기",
    标的币种: "목표 화폐 종류",
    一键报名: "원클릭 신청",
    选择您感兴趣的项目并报名: "관심 항목 선택 및 신청",
    等待释放: "석방을 기다리다",
    等待计算您将获得的代币数量: "획득할 토큰 수량을 계산하기 위해 대기 중",
    获得代币: "토큰 획득",
    前往现货账户查看获得的代币: "현물 계좌로 가서 획득한 토큰을 확인하다",
    locking1: "안정적으로 저축하고, 수익이 높고, 마음이 더욱 편안하다!",
    locking2: "FLOKI를 질권하여 TOKEN을 벌다",
    立即登录: "지금 로그인",
    项目名: "프로젝트 이름",
    年化收益率: "연간 수익률",
    结算日期: "결제 날짜",
    锁仓天数: "창고 잠금 일수",
    锁仓进度: "창고 잠금 진도",
    天: "일",
    我要支付: "지불하겠습니다.",
    我将收到: "받겠습니다",
    购买数字货币: "디지털 화폐 구매",
    btc1: "이 페이지에는 LBank를 통해 100 개 이상의 인기있는 디지털 통화를 원하는 프랑스 통화로 변환 할 수있는 디지털 통화와 프랑스 통화의 실시간 환율이 표시됩니다.원하는 프랑스 화폐를 사용 가능한 디지털 화폐 자산으로 전환할 수도 있습니다.",
    btc2: "상위 50개 디지털 화폐와 프랑스 화폐의 환율",
    展开: "확장",
    收起: "집어치우다",
    数字货币: "디지털 화폐",
    轻松跟单: "간편한 주문 처리, 지능형 트랜잭션",
    顶级带单员: "최고급 리본 단원",
    全部带单员: "전부 홀인원",
    最高收益率: "최고 수익률",
    获得最高收益率的带单员: "가장 높은 수익률을 얻은 홀인원",
    今日最佳: "오늘 최고",
    最高收益: "최대 이익",
    赚取最高带单收益的带单员: "최대 청구서 수익을 올리는 청구서 담당자",
    新晋带单员: "신진 (新晋) 이 단원을 거느리다.",
    最低回撤: "최소 철수",
    交易风险最稳定的带单员: "거래 위험이 가장 안정적인 주문자",
    最高跟随者收益: "최대 추종자 이익",
    带领跟随者获得最高收益的带单员: "추종자를 이끌고 최고 수익을 얻는 단역원",
    综合排名: "종합 순위",
    收益率: "수익률",
    胜率: "승률",
    收益: "이익",
    跟随者收益: "추종자 이익",
    最大回撤: "최대 복귀",
    筛选: "필터링",
    隐藏满员: "만원 숨기기",
    更多: "추가",
    跟单: "주문",
    空位提醒: "빈자리 알림",
    成为带单员: "홀인원이 되다",
    跟单教程: "주문 자습서",
    跟单周动态: "및 주간 동적",
    明星带单员: "스타와 단원",
    产品更新与热门活动一览: "제품 업데이트 및 주요 이벤트 요약",
    火箭团团长: "로켓단 단장",
    总收益: "총 이익",
    copy1: "지난 7일 동안 최고의 활약을 펼친 밴드 멤버 차트",
    copy2: "고수익, 저회수 신진 벨트 단원",
    help1: "자산 동결이란 무엇입니까?",
    help2: "자산 동결이란 귀하가 어떤 거래를 할 때 절차가 아직 완성되지 않았고 현재 자산이 잠시 시스템에 의해 관리되어 귀하가 자유롭게 사용할 수 없으며 귀하의 자산이 분실되거나 자산에 이상이 생기는 것을 의미하지 않으므로 안심하십시오.",
    help3: "선물 거래의 규칙은 무엇입니까?",
    help4: "현재 거래 쌍의 다음 가격 추세 (상승 또는 하락) 를 예측하여 거래에 참여합니다.결산할 때 상승폭이나 하락폭을 계산하지 않고 상승폭이나 하락폭의 리윤만 계산한다.서로 다른 결제 시간에 결산하는 이윤의 백분율이 다르기 때문에 이윤은 거래 인터페이스에 정확하게 나타날 것이다.",
    help5: "자산 충전, 현금 인출을 위해 전환해야 하는 USDT 수량, 어떻게 전환합니까?",
    help6: "자산 충전, 현금 인출 금액은 귀하가 충전, 현금 인출에 사용하는 화폐/USDT의 실시간 가격 변동에 따라 변경됩니다. 사실 귀하의 자산은 변하지 않았습니다.",
    help7: "거래 비밀번호를 잊어버리면 어떻게 합니까?",
    help8: "거래 비밀번호를 잊어버린 경우 【개인센터】오른쪽 상단에서 【안전센터】【거래비밀번호】를 클릭하여 수정할 수 있습니다. 구체적인 절차는 다음과 같습니다.",
    help9: "1. 휴대폰 번호가 연결되어 있으면 휴대폰 번호 인증번호를 받아야 한다",
    help10: "2. 메일박스를 바인딩한 경우 메일박스 인증번호를 받아야 한다",
    help11: "3. 새 거래 비밀번호 입력",
    help12: "4. 새 거래 비밀번호 확인",
    help13: "5.【제출】클릭",
    help14: "로그인 비밀번호를 잊어버리면 어떻게 합니까?",
    help15: "로그인 비밀번호를 잊으셨다면 [로그인 페이지] [비밀번호를 잊으셨습니까?] 로 이동하여 메일박스 또는 휴대폰 인증번호를 획득하고 새 로그인 비밀번호를 설정할 수 있습니다.",
    help16: "어떻게 계좌 안전을 강화합니까?",
    help17: "귀하의 계정에 더 복잡하고 안전한 비밀번호를 만들고 귀하의 개인 정보를 누구와도 공유하지 마십시오.",
    protocol1: "이 웹 사이트는 외환 및 디지털 자산 거래 및 관련 서비스를 전문으로 하는 플랫폼 (이하 \"본 서비스\" 또는 \"서비스\") 입니다.본 계약의 편의를 위해 본 웹 사이트는 본 계약에서 \"우리\" 또는 기타 1인칭 용어를 사용합니다.본 계약의 편의를 위해 아래에 \"귀하\" 또는 기타 2인칭 용어를 사용합니다.본 협의의 편의를 위해 저희는 귀하와 본 협의에서'쌍방'이라고 합칭하고 저희나 귀하는 단독으로'일방'이라고 부릅니다.",
    protocol2: "중요 팁:",
    protocol3: "특히 다음과 같은 사항을 알려드립니다.",
    protocol4: "디지털 자산 자체는 금융 기관 또는 회사 또는 웹 사이트에서 발행되지 않습니다.",
    protocol5: "디지털 자산 시장은 신흥이고 확인되지 않았으며 성장하지 않을 수 있습니다.",
    protocol6: "디지털 자산은 주로 투기꾼들이 사용하며 소매와 상업 시장에서 상대적으로 적게 사용된다.그들은 하루 종일 거래하고 등락 제한이 없으며 가격은 농가와 글로벌 정부 정책의 영향을 받아 파동이 비교적 크다;",
    protocol7: "디지털 자산 거래는 대부분의 사람들에게 적합하지 않은 매우 큰 위험을 가지고 있습니다.귀하는 이 거래가 일부 또는 전부의 손실을 초래할 수 있음을 이해하고 이해하므로 귀하는 귀하가 감당할 수 있는 손실 정도에 따라 거래 금액을 확정해야 합니다.디지털 자산의 매매에 대한 결정을 내리기 전에 귀하는 귀하의 재무 상황과 상술한 위험을 평가하고 이로 인해 발생하는 모든 손실을 부담하기 위해 명확한 판단을 잘 고려하고 사용해야 합니다.우리는 이에 대해 어떠한 책임도 지지 않는다.",
    protocol8: "공지 사항:",
    protocol9: "귀하는 이 사이트가 귀하가 디지털 자산 정보를 얻고 거래자를 찾으며 디지털 자산에 대해 협상하고 거래하는 장소일 뿐이라는 것을 이해합니다.",
    protocol10: "소프트웨어, 하드웨어 및 인터넷 연결 장애를 포함하되 이에 국한되지 않는 인터넷 기반 거래 시스템을 사용하는 것도 위험합니다.인터넷의 신뢰성과 가용성을 제어할 수 없으므로 왜곡, 지연 및 접속 장애에 대해 책임을 지지 않습니다.",
    protocol11: "1. 총칙",
    protocol12: "\"사용자 계약\"(이하\"본 계약\"또는\"본 조항\") 은 본문,\"프라이버시 조항\",\"당신의 고객 및 돈세탁 방지 정책 이해\"및 본 사이트가 이미 발표했거나 앞으로 발표할 수 있는 각종 규칙, 성명, 설명 등으로 구성된다.",
    protocol13: "귀하는 본 사이트에서 제공하는 서비스를 사용하기 전에 본 협의를 자세히 읽어야 합니다.귀하가 본 계약에 동의하지 않거나 언제든지 수정할 경우 본 사이트에서 제공하는 서비스의 사용을 즉시 중지하거나 본 사이트의 로그인을 중지하십시오.귀하가 본 사이트에 로그인하거나 본 사이트의 서비스를 사용하거나 기타 유사한 행위를 하면 귀하는 본 협의의 모든 내용을 이해하고 전적으로 동의한 것으로 본 협의에 대한 수정을 포함합니다.",
    protocol14: "본 사이트의 회원이 되면 귀하는 하나의 회원 계정과 상응하는 비밀번호를 얻을 것입니다. 귀하는 이 계정과 비밀번호를 잘 보관할 책임이 있습니다.귀하는 귀하의 계정에서 진행하는 모든 활동과 사건에 대해 법적 책임을 져야 합니다.",
    protocol15: "이 웹 사이트에서 제공하는 모든 서비스 및 기능을 등록 및 사용함으로써 귀하는 읽은 것으로 간주되고 이해됩니다.",
    protocol16: "본 계약의 모든 약관에 동의합니다.",
    protocol17: "귀하는 귀하가 만 18세가 되었거나 서로 다른 관련 법률에 따라 계약을 체결하는 법정 연령이 있음을 확인합니다.",
    protocol18: "귀하는 거래소와 관련된 디지털 자산이 합법적으로 획득되고 소유된다는 것을 보증합니다.",
    protocol19: "귀하는 귀하의 거래 또는 비거래 행위와 수익이나 손실에 대해 모든 책임을 지는 것에 동의합니다.",
    protocol20: "등록 시 제공되는 정보가 정확한지 확인합니다.",
    protocol21: "2. 협의 개정",
    protocol22: "저희는 언제든지 본 협의를 수정하고 사이트에 공고할 권리를 보유하며 귀하께 따로 통지할 필요가 없습니다.",
    protocol23: "3. 등록",
    protocol24: "등록 자격",
    protocol25: "귀하는 귀하가 등록 절차를 완료하거나 본 사이트가 허용하는 다른 방식으로 본 사이트가 제공하는 서비스를 실제로 사용할 때 귀하는 본 협의에 서명하고 본 사이트의 서비스를 사용할 수 있는 법률에 적용될 수 있는 능력을 가진 자연인, 법인 또는 다른 조직이어야 한다는 것을 확인하고 약속합니다.귀하가 \"등록 동의\" 단추를 클릭하면 귀하 또는 귀하의 권한 수여 대리인이 본 협의의 내용에 동의했고 귀하를 대표하여 본 사이트의 서비스를 등록하고 사용하게 됩니다.",
    protocol26: "등록 목적",
    protocol27: "귀하는 본 사이트의 등록이 법률과 법규를 위반하거나 본 사이트의 디지털 자산 거래 질서를 어지럽히기 위한 것이 아니라는 것을 확인하고 약속합니다.",
    protocol28: "등록 프로세스",
    protocol29: "귀하는 본 사이트에 유효한 이메일, 핸드폰 번호 등 정보를 제공하는 것에 동의하고 본 사이트에 본 사이트 서비스를 등록하고 사용하는 것에 동의합니다.이 웹 사이트 사용자 등록 페이지의 요구 사항을 따릅니다.귀하는 귀하가 제공하거나 확인한 이메일, 핸드폰 번호 또는 본 사이트에서 허용하는 다른 방법을 사용하여 본 사이트에 로그인할 수 있습니다.그러한 정보의 신뢰성, 무결성 및 정확성에 대한 책임은 귀하가 져야 하며 이로 인해 발생하는 모든 직접적 또는 간접적 손실과 불리한 결과를 책임져야 합니다.",
    protocol30: "귀하는 합법적이고 완전하며 효과적으로 등록에 필요한 정보를 제공하고 확인한 후에 본 사이트의 계정과 비밀번호를 얻을 권리가 있습니다.귀하가 본 사이트의 계정과 비밀번호를 얻으면 귀하가 이미 등록한 것으로 간주하고 본 사이트에 로그인할 수 있습니다.",
    protocol31: "귀하는 본 사이트에서 발송한 본 사이트의 관리, 운영과 관련된 이메일 및/또는 문자 메시지를 받는 것에 동의합니다.",
    protocol32: "4. 서비스",
    protocol33: "이 웹 사이트에서는 이 웹 사이트를 통한 디지털 자산 거래 활동에만 웹 거래 플랫폼 서비스를 제공합니다.",
    protocol34: "서비스 내용",
    protocol35: "귀하는 본 사이트에서 각종 디지털 자산 상품의 실시간 시세와 거래 정보를 조회할 권리가 있고 본 사이트를 통해 디지털 자산 거래 지령을 제출하고 디지털 자산 거래를 완성할 권리가 있습니다.",
    protocol36: "서비스 규칙 귀하는 본 사이트의 다음 서비스 규칙을 준수할 것을 약속합니다.",
    protocol37: "귀하는 법률, 법규, 규정 및 정책 요구의 규정을 준수해야 합니다. 여기에는 불법, 불법 또는 타인의 권리를 침해하는 모든 정보를 발송하거나 수신하는 것, 다단계 판매 자료나 기타 유해 정보나 언론을 발송하거나 수신하는 것, 본 사이트의 허가 없이 본 사이트의 전자 우편 헤더 정보를 사용하거나 위조하는 것 등이 포함되지만 이에 국한되지 않습니다.",
    protocol38: "귀하는 법률과 법규를 준수하고 귀하의 계좌번호 및 로그인 비밀번호, 자금 비밀번호, 귀하가 등록할 때 귀속된 핸드폰 번호, 핸드폰으로 받은 핸드폰 인증번호 등을 적절하게 사용하고 보관해야 합니다.귀하는 귀하의 계좌 및 로그인 비밀번호, 자금 비밀번호, 핸드폰 인증 코드를 사용한 어떠한 조작과 결과에 대해 모든 책임을 져야 합니다.귀하가 귀하의 본 사이트 계정, 로그인 비밀번호, 자금 비밀번호, 인증 코드가 제3자에 의해 무단으로 사용되거나 다른 계정의 안전 문제가 존재하는 것을 발견하면 귀하는 본 사이트에 즉시 유효하게 통지하여 본 사이트 계정의 서비스를 정지하도록 요구해야 합니다.",
    protocol39: "귀하는 본 사이트에서 디지털 자산 거래를 할 때 디지털 자산 거래의 정상적인 진행을 악의적으로 방해하고 거래 질서를 어지럽혀서는 안 됩니다.어떠한 기술적 수단이나 다른 방식으로도 본 사이트의 정상적인 운행을 방해하거나 다른 사용자가 본 사이트의 서비스를 사용하도록 방해할 수 없다.사실을 허구하는 등의 방식으로 본 사이트의 명예를 악의적으로 비방할 수 없다.",
    protocol40: "제품 규칙",
    protocol41: "거래 정보 찾아보기",
    protocol42: "귀하는 본 사이트에서 거래 정보를 조회할 때 거래 정보에 포함된 모든 내용을 자세히 읽어야 합니다. 가격, 위탁량, 수수료, 매입 또는 매도 방향 등을 포함하되 이에 국한되지 않습니다.귀하는 거래 정보에 포함된 모든 내용을 완전히 수락한 후에야 단추를 눌러 거래를 진행할 수 있습니다.",
    protocol43: "주문 전송",
    protocol44: "거래 정보를 탐색하고 오류가 없음을 확인한 후 거래 주문을 제출할 수 있습니다.",
    protocol45: "거래 상세 정보 보기",
    protocol46: "귀하는 귀하의 계좌를 통해 해당하는 거래 기록을 볼 수 있습니다.",
    protocol47: "5. 본 사이트의 권리와 의무",
    protocol48: "귀하가 본 협의에 규정된 등록 자격을 갖추지 못하면 본 사이트는 귀하의 등록을 거부할 권리가 있으며 본 사이트는 귀하 또는 귀하의 권한 수여 대리인에게 책임을 추궁할 권리를 가집니다.또한 본 사이트는 다른 어떠한 경우에도 귀하의 등록을 수락할지 여부를 결정할 권리를 보유합니다.",
    protocol49: "만약에 본 사이트에서 계정 사용자가 계정의 원래 등록자가 아닌 것을 발견하면 계정의 사용을 정지하거나 중지할 권리가 있다.",
    protocol50: "본 사이트에서 본 사이트에 제시된 모든 정보에 명백한 오류가 발견되면 본 사이트는 정보를 수정할 권리가 있습니다.",
    protocol51: "본 사이트는 언제든지 본 사이트의 서비스를 수정, 중지 또는 종료할 권리를 보유합니다.본 사이트는 서비스를 수정하거나 중지할 권리를 행사할 때 사전에 귀하에게 통지할 필요가 없습니다.본 사이트는 본 사이트의 하나 이상의 서비스를 종료하고 본 사이트가 사이트에 종료 공고를 발표한 날부터 효력을 발생한다.",
    protocol52: "6. 책임제한 및 면책조항",
    protocol53: "귀하는 어떠한 경우에도 저희는 다음 사항에 대해 책임을 지지 않는다는 것을 이해하고 동의합니다.",
    protocol54: "Lo 수익 손실;",
    protocol55: "거래 이윤 또는 계약 손실;",
    protocol56: "업무 중단으로 인한 손실",
    protocol57: "데이터 손상 또는 손실",
    protocol58: "귀하는 다음과 같은 상황에서 발생하는 어떠한 손실에 대해서도 책임을 지지 않는다는 것을 이해하고 동의합니다.",
    protocol59: "귀하의 구체적인 거래는 중대한 위법 또는 위약 행위와 관련될 수 있습니다.",
    protocol60: "이 웹 사이트에서의 귀하의 행위는 불법적이거나 비윤리적인 것으로 의심됩니다.",
    protocol61: "본 웹 사이트에서 제공하는 서비스와 관련되지 않은 기타 손해",
    protocol62: "7. 협의 종료",
    protocol63: "본 사이트는 본 협의의 규정에 따라 본 사이트의 모든 서비스를 종료할 권리가 있으며 본 협의는 본 사이트의 모든 서비스가 종료되는 날에 종료한다.",
    protocol64: "본 계약이 종료된 후 귀하는 본 사이트에 서비스를 계속 제공하거나 다른 의무를 이행하도록 요구할 권리가 없습니다. 여기에는 본 사이트가 귀하에게 본 사이트의 계정에 있는 모든 정보를 보존하거나 공개하도록 요구하거나 귀하 또는 제3자에게 읽지 않았거나 발송한 모든 정보를 전달하도록 요구하거나 이에 국한되지 않습니다.",
    protocol65: "본 협의의 종료는 계약을 지키는 측이 위약자에게 기타 책임을 지도록 요구하는 의무에 영향을 주지 않는다.",
    protocol66: "8. 정보 보호",
    protocol67: "본 사이트가 별도로 공포한 프라이버시 조항의 규정은 기준이다.",
    privacy1: "데이터 보호에 전념하고 있습니다.",
    privacy2: "개인 정보 보호 정책에 오신 것을 환영합니다.",
    privacy3: "Google은 귀하가 Google 개인 정보 보호 프로그램의 핵심 측면을 이해하고 귀하의 개인 정보 보호 권리에 대한 더 많은 정보를 얻을 수 있도록 이 페이지를 만들었습니다.",
    privacy4: "Crocodile 에서는 개인 정보와 데이터를 보호하기 위해 최선을 다하고 있습니다.귀하의 개인정보 안전은 저희에게 매우 중요합니다. 저희는 엄격한 내부 준칙, 법률 요구와 업계 모범 사례를 준수하여 귀하의 데이터가 안전하고 권한 수여 목적에만 사용되도록 합니다.",
    privacy5: "Crocodile 의 개인 정보 보호 정책",
    privacy6: "항상 투명하게 유지",
    privacy7: "투명성에 대한 Dell의 약속은 귀하의 데이터 사용과 공유 방식을 귀하께 알려드립니다.이 포털과 개인 정보 보호 정책을 정기적으로 업데이트하여 귀하가 귀하에게 영향을 미칠 수 있는 모든 변경 사항을 항상 알고 있는지 확인합니다.이를 통해 귀하의 데이터와 개인 정보에 대해 현명한 결정을 내릴 수 있습니다.",
    privacy8: "책임성 및 규정 준수",
    privacy9: "우리는 우리의 프라이버시 책임을 진지하게 대한다.Dell의 접근 방식은 전 세계적으로 적용되는 데이터 보호 법률 및 규정을 완벽하게 준수합니다.Dell은 정기적으로 감사를 실시하고 프로세스를 지속적으로 개선하여 데이터 보호 및 개인 정보 보호 표준을 준수하고 있습니다.우리의 프로그램은 우리가 운영하는 여러 관할 구역에서 탐나는 보안 및 개인 정보 보호 인증을 받았습니다.",
    privacy10: "데이터 보안",
    privacy11: "저희는 귀하의 프라이버시와 안전을 최우선으로 고려하여 귀하의 데이터를 분실, 남용 또는 무단 액세스로부터 보호하는 강력한 조치를 실시하고 내부 액세스를 엄격히 통제합니다.Dell의 고급 암호화 및 엄격한 프로토콜 (인증 포함) 은 귀하의 데이터의 기밀성과 무결성을 유지합니다.",
    privacy12: "데이터 최소화 및 목적 제한",
    privacy13: "Crocodile 가 제공하는 모든 제품과 서비스가 특정 목적으로만 사용자 데이터를 수집하도록 강력한 데이터 최소화 거버넌스 제어를 구현했습니다.저희는 개인 정보 보호 정책에 Crocodile 데이터 수집의 구체적인 합법적인 상업적 목적을 설명했습니다.",
    privacy14: "사용자 권한 및 액세스",
    privacy15: "저희는 귀하의 개인 데이터에 대한 기본적인 권리를 인정하고 보호합니다.귀하가 이러한 권리를 행사할 수 있도록 Crocodile 응용 프로그램과 전용 네트워크 양식을 통해 사용하기 쉬운 도구와 메커니즘을 제공합니다. 귀하는 여기에서 지원을 요청할 수 있습니다.관할 구역에 적용되는 권한에 대한 자세한 내용은 다음 링크의 개인 정보 보호 정책을 참조하십시오.귀하의 권리를 행사하려면 이 페이지의 \"개인 정보 보호권 행사\" 섹션을 읽으십시오.",
    privacy16: "개인 정보 보호 설계",
    privacy17: "저희는 프라이버시와 데이터 보호가 모든 제품과 서비스에 통합되도록 엄격한 절차를 제정했습니다.Dell의 전담 개인 정보 보호 팀은 개발자와 긴밀히 협력하여 글로벌 표준 및 규정을 준수하는 방식으로 데이터 보호 설계 및 기본 설정을 통합합니다.",
    privacy18: "이 개인 정보 보호 정책은 Crocodile 플랫폼, 웹 사이트 및 부서에서 수행하는 모든 개인 데이터 처리 활동에 적용됩니다.",
    privacy19: "귀하가 저희 서비스의 고객이나 사용자인 경우 본 프라이버시 성명은 저희가 귀하와 체결한 어떠한 협의도 포함하고 이에 국한되지 않습니다.",
    privacy20: "귀하가 저희 서비스의 관련 이해관계자, 고객 또는 사용자가 아니지만 저희 사이트를 사용하고 있는 경우 본 프라이버시 성명서도 귀하께 적용됩니다.",
    other1: "Crocodile 정보",
    other2: "Crocodile 개인 정보 보호 정책",
    other3: "Crocodile 소개",
    other4: "7개월 전",
    语言: "언어",
    'question1': '왜 Crocodile Exchange를 선택해야 하나요?',
    'answer1': 'Crocodile Exchange는 2021년 캐나다에서 설립되었으며, 미국 재무부(FinCEN)의 규제를 받고 MSB(Money Services Business) 라이선스를 취득했습니다.',
    'question2': '계정을 어떻게 등록하나요? 어떤 자료가 필요하나요?',
    'answer2': '휴대폰 번호만으로 계정을 등록할 수 있습니다. 등록 후 KYC(신원 인증)를 완료해야 하며, 여기에는 신분증이나 운전면허증 업로드가 포함되어 계정 보안을 보장합니다.',
    'question3': '추천 보상이 있나요? 친구를 어떻게 초대하나요?',
    'answer3': '모든 사용자에게는 고유한 초대 코드가 있습니다. 친구를 성공적으로 초대하고 첫 거래를 완료하면 추천 커미션 보상을 받게 되며, 이 커미션은 실시간으로 인출할 수 있어 기다릴 필요가 없습니다.',
    'question4': '플랫폼은 어떻게 내 자금을 보호하나요?',
    'answer4': '저희는 다중 콜드 월렛 + 핫 월렛 분리 메커니즘을 사용하며, 사용자 자산의 대부분은 오프라인 콜드 월렛에 저장됩니다. 또한, 플랫폼에는 다중 서명 메커니즘과 실시간 위험 관리 시스템이 마련되어 있어 자금이 안전하게 보호됩니다.',
    "下载App": "앱 다운로드",
    "扫描并下载": "스캔 후 다운로드",
    "全球": "글로벌",
    "顶尖": "최상위",
    "加密货币": "암호화폐",
    "交易平台": "거래 플랫폼",
    "使用美元买入Bitcoin、Ethereum和多种加密货币": "달러로 Bitcoin, Ethereum 및 다양한 암호화폐 구매",
    "通过加密货币、电汇等多种方式存入资金*": "암호화폐, 전신환 등 다양한 방법으로 자금 입금*",
    "業界領先的法遵與資安認證": "업계 선두의 규정 준수 및 보안 인증",
    "深受全球 1 億以上用戶信賴": "전 세계 1억 명 이상의 사용자에게 신뢰받는 서비스"
}
